import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_APPLICANT_DETAIL_GET',
  GET_SUCCESS: 'TEACHER_APPLICANT_DETAIL_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_APPLICANT_DETAIL_GET_FAILURE',
};

export const get = actions.get(
  applicantId => `${BASE_URL}/teacher-applicants/${applicantId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
